<div class="listSection">
    <app-order-board></app-order-board>

    <div class="listWrapper">
        <hr>
        
        <div class="ListTitle">
            aqui vem o nome do restaurante, cnpj, e os dados do dia
        </div>

        <hr>

        <div class="listContent">
            aqui vem os detalhes do pedido, quantidades, observações
        </div>

        <hr>

        <div class="listFooter">
            aqui vem os detalhes de entrega, quem entregou e talz
        </div>

    </div>
</div>